import React, { useEffect, useState } from 'react';
import {
    Box,
    IconButton,
    Typography,
    Tooltip,
    TextField,
    Button
} from '@mui/material';
import { ArrowBack, Clear } from '@mui/icons-material';
import { StyledSubMenuContainer } from '../../../Utils/styledComps';

const CustomSprayPopoverContent = ({
    spraySelectRef,
    handleSpraying,
    handlePopoverClose,
    areaOfSpray,
    setAreaOfSpray,
    numberOfCopies,
    setNumberOfCopies,
    activeObj,
}) => {

    const renderPopoverContent = () => {
        return (
            <Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    px: 1.25,
                    py: 1
                }}>
                    <Typography variant="h6" sx={{ color: 'action.hover', fontWeight: 800 }}>
                        Spray Shapes
                    </Typography>
                    <Tooltip title="Close menu" arrow>
                        <IconButton
                            edge="end"
                            onClick={handlePopoverClose}
                            aria-label="Close spray menu"
                            sx={{ borderRadius: 1 }}
                        >
                            <Clear />
                        </IconButton>
                    </Tooltip>
                </Box>

                <StyledSubMenuContainer>
                    {activeObj ? (
                        <Box sx={{
                            display: 'flex',
                            rowGap: 1,
                            flexDirection: 'column',
                            m: 1.25,
                            flexWrap: 'wrap'
                        }}>
                            <TextField
                                type='number'
                                value={numberOfCopies}
                                label='No. Of Copies'
                                onChange={(e) => {
                                    setNumberOfCopies(e.target.value);
                                    console.log('no.OfCopies: ', e.target.value, numberOfCopies);
                                }}
                                fullWidth
                            />
                            <TextField
                                type='number'
                                value={areaOfSpray}
                                label='Area Of Spray'
                                onChange={(e) => setAreaOfSpray(e.target.value)}
                                fullWidth
                            />
                            <Button
                                variant='contained'
                                onClick={handleSpraying}
                                fullWidth
                                sx={{
                                    mt: 1,
                                    transition: (theme) => theme.transitions.create(['transform', 'box-shadow'], {
                                        duration: theme.transitions.duration.shorter,
                                    }),
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                                    }
                                }}
                            >
                                {spraySelectRef.current ? 'Disable' : 'Enable'}
                            </Button>
                        </Box>
                    ) : (
                        spraySelectRef.current ? (
                            handleSpraying()
                        ) : (
                            <Box sx={{
                                display: 'flex',
                                rowGap: 1,
                                flexDirection: 'column',
                                m: 1.25,
                                flexWrap: 'wrap'
                            }}>
                                <Typography sx={{ color: 'text.primary', textAlign: 'center', py: 2 }}>
                                    Please Select an object first.
                                </Typography>
                            </Box>
                        )
                    )}
                </StyledSubMenuContainer>
            </Box>
        );
    };

    return (
        <>
            {renderPopoverContent()}
        </>
    );
};

export default CustomSprayPopoverContent;
